// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"33ac9202","787":"a71561b8"}[chunkId] + ".chunk.js";
};